import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import LogoCard from "../../shared/logo-card";
import TransparentButton from "../../shared/button/transparent-button";
import { STEP_NAMES } from "../../../constants/app-constants";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import { ArrowIcon } from "@cars24/turbo-web/lib/icons/arrow-icon";
import RightArrow from "./images/right-arrow.svg";

const CarBrands = ({
    popularItems,
    nextStep = () => {},
    stepName,
    setData = () => {},
    size,
    expandable,
    selected,
    isRevamped = false,
    customClass = "",
    onMoreClickCallback = () => {},
    landingLeadForm = false,
    isLazyLoad = true,
    showAll = false,
    onBrandClick = () => {},
    isLuxuryPage,
    ctaText = "VIEW ALL"
}) => {

    const brandsToDisplay = showAll
        ? popularItems || []
        : (popularItems || []).slice(0, size);

    const onClickHandler = (selectedBrand) => {
        setData({ type: stepName, data: selectedBrand });
        nextStep(STEP_NAMES.Model);
        onBrandClick(selectedBrand);
    };

    const onMoreClickHandler = () => {
        if (!isRevamped) {
            nextStep(STEP_NAMES.Brand);
        }
        onMoreClickCallback();
    };

    const renderLogoCards = () => {
        // eslint-disable-next-line camelcase
        return brandsToDisplay.map(({ logo, make_display, make_id }, index) => {
            return (
                <li
                    key={index}
                    styleName={`${landingLeadForm ? "styles.listCol" : ""} styles.customCol`}
                >
                    <LogoCard
                        // eslint-disable-next-line camelcase
                        selected={selected === make_id}
                        image={logo}
                        landingLeadForm={landingLeadForm}
                        // eslint-disable-next-line camelcase
                        altText={make_display}
                        onClick={() =>
                            onClickHandler({
                                displayText: make_display,
                                id: make_id
                            })
                        }
                        isLazyLoad={isLazyLoad}
                    />
                </li>
            );
        });
    };
    const footerButton = () => {
        if (expandable) {
            return (
                <li styleName={"styles.customCol styles.moreButton"}>
                    <TransparentButton text={ctaText} onClick={onMoreClickHandler} />
                </li>
            );
        } else {
            return (
                <div styleName={`styles.viewButton ${isLuxuryPage ? "styles.eliteViewall" : "" }`}>
                    <LinkButton
                        href="#"
                        label="View All"
                        onClick={onMoreClickHandler}
                        suffixIcon={isLuxuryPage ? <img src={RightArrow} alt="right arrow" width="28px"/> : <ArrowIcon size="14px" />}
                        variant={isLuxuryPage ? "black" : "brand"}
                        size={isLuxuryPage ? "medium" : "small"}
                        preventDefaultBehaviour
                    />
                </div>
            );
        }
    };

    return (
        <div>
            <ul className={`row ${customClass}`} styleName={"styles.customRow"}>
                {renderLogoCards()}
                {footerButton()}
            </ul>
        </div>
    );
};

CarBrands.propTypes = {
    isSSR: PropTypes.bool,
    isRevamped: PropTypes.bool,
    fetchDataConnect: PropTypes.func,
    setBrandConnect: PropTypes.func,
    popularItems: PropTypes.array.isRequired,
    history: PropTypes.object,
    onBrandClick: PropTypes.func,
    all: PropTypes.array,
    nextStep: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
    stepName: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    selected: PropTypes.number.isRequired,
    expandable: PropTypes.bool.isRequired,
    customClass: PropTypes.string,
    onMoreClickCallback: PropTypes.func,
    landingLeadForm: PropTypes.bool,
    isLazyLoad: PropTypes.bool,
    showAll: PropTypes.bool,
    isLuxuryPage: PropTypes.bool,
    ctaText: PropTypes.string
};

export default CarBrands;

